// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 18 17"
    {...props}
  >
    <path
      fill="#FDD012"
      d="M8.12207 0.609787C8.50107 -0.085154 9.49893 -0.0851549 9.87793 0.609786L11.888 4.29546C12.0318 4.55919 12.2866 4.74429 12.5818 4.79958L16.7083 5.57232C17.4863 5.71802 17.7947 6.66704 17.2509 7.24224L14.3667 10.2929C14.1603 10.5111 14.063 10.8106 14.1017 11.1085L14.6419 15.2718C14.7438 16.0568 13.9365 16.6433 13.2214 16.3039L9.42883 14.5036C9.15746 14.3747 8.84255 14.3747 8.57117 14.5036L4.77861 16.3039C4.06352 16.6433 3.25624 16.0568 3.3581 15.2718L3.89832 11.1085C3.93697 10.8106 3.83966 10.5111 3.63329 10.2929L0.749139 7.24224C0.205328 6.66704 0.513682 5.71802 1.29173 5.57232L5.41816 4.79958C5.71342 4.74429 5.96819 4.55919 6.11202 4.29546L8.12207 0.609787Z"
    />
  </svg>
);
const IconYellowStar = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconYellowStar;
